import * as React from 'react'
import Visible from '@material-ui/icons/Visibility'
import Invisible from '@material-ui/icons/VisibilityOff'
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
    icon: {
        height: "16px",
        width: "16px"
    }
})

interface IsVisibleProps {
    isVisible: boolean;
}

type VisibilityProps = IsVisibleProps & WithStyles<"icon">

const Visibility: React.SFC<VisibilityProps> = (props) => {
    const { classes } = props;

    return <span>{props.isVisible ? <Visible className={classes.icon} color="primary" /> : <Invisible className={classes.icon} color="error" />}</span>
}

export default withStyles(styles)(Visibility);


// WEBPACK FOOTER //
// ./src/components/Visibility.tsx